function computeRem(baseWidth, baseRem) {
    var winWidth = document.documentElement.clientWidth;
    if (winWidth <= 320) winWidth = 320;
    if (winWidth >= baseWidth) winWidth = baseWidth;
    var targetRem = winWidth / (baseWidth / 2) * baseRem;
    document.documentElement.style.fontSize = targetRem + "px";
}

var rem = {
    useRem: function (baseWidth, baseRem) {
        computeRem(baseWidth, baseRem);
        window.addEventListener("resize", function () {
            computeRem(baseWidth, baseRem)
        });
    }
}
export default rem;


// WEBPACK FOOTER //
// ./src/tools/rem.js